import { createSelector } from 'reselect'
import {mod} from "utils/mod.js";

const NUM_STEPS = 7;

const getPattern = (pattern, currentStep) => pattern;
const getStepBuckets = (pattern, currentStep) => pattern.stepBuckets;
const getCurrentStep= (pattern, currentStep) => currentStep;
export const getSteps = 
    (pattern, currentStep) => {
        let length = pattern.length();
        let steps = [];
        for (let i=-7; i <= 7; i++) {
            let stepNumber = mod((currentStep + i)*2, length);
            let stepBucket = pattern.stepBuckets[stepNumber];
            let onStep = stepBucket.getAnyOnStep() || stepBucket.steps[0];
            steps.push({stepData: onStep, stepNumber: stepNumber / 2});
        }
        return steps;
    };

